import store from '../store';
import dataRoutes from './module/data.js';  				// 数据统计模块
import decorateRoutes from './module/decorate.js';  		// 装修相关
import financeRoutes from './module/finance.js';  			// 财务模块
import marketingRoutes from './module/marketing.js';  		// 营销活动
import memberRoutes from './module/member.js';  			// 代理相关
import operationRoutes from './module/operation.js';  		// 运营相关
import orderRoutes from './module/order.js';  				// 订单相关
import productRoutes from './module/product.js';  		    // 商品相关
import sellerRoutes from './module/seller.js';  		    // 经销商相关
import srmRoutes from './module/srm.js';  		    		// 商家相关
import systemRoutes from './module/system.js';  		    // 系统功能相关
import momentsRoutes from './module/moments.js';  		    // 社区功能相关

export default [{
	path: '/login',
	name: 'login',
	component: () => import('@/pages/login/index'),
	beforeEnter: (to, from, next) => {
		if (store.state.session) {
			next('/');
		} else {
			next();
		}
	}
}, {
	path: '/',
	component: () => import('@/pages/index'),
	children: [
		{
			path: '',
			name: 'home',
			component: () => import('@/pages/home/index')
		},
		...dataRoutes,
		...decorateRoutes,
		...financeRoutes,
		...marketingRoutes,
		...memberRoutes,
		...operationRoutes,
		...orderRoutes,
		...productRoutes,
		...sellerRoutes,
		...srmRoutes,
		...systemRoutes,
		...momentsRoutes
	]
}, {
	path: '/decorate_manage/:type',
	name: 'decorate_manage',
	meta: {
		title: '装修系统'
	},
	props: route => Object.assign(route.query, route.params),
	component: () => import('@/submodule/decorate_manage/index')
}, {
	path: '/oss_manage',
	name: 'oss_manage',
	meta: {
		title: '图片空间'
	},
	component: () => import('@/submodule/oss_manage/index')
}, {
	path: '/kanban',
	name: 'm_kanban',
	meta: {
		title: '数据看板'
	},
	component: () => import('@/pages/kanban/index')
}, {
	path: '*',
	redirect: '/'
}];